<div
    class="anc-side-panel-overlay"
    [style.background]="overlayBackground() ?? null"
    (click)="onBackdropClick($event)"
>
    <div
        class="anc-side-panel"
        [class.anc-side-panel--forms]="variant() === 'forms'"
        [class.anc-side-panel--details]="variant() === 'details'"
        [style.width]="resolvedWidth()"
        [style.background]="background()"
        (click)="$event.stopPropagation()"
    >
        @if (title()) {
            <lib-anc-page-header
                class="anc-side-panel__header"
                [title]="title()"
                [titleBordered]="titleBordered()"
                (closeClick)="closeClick.emit()"
            />
        }
        <div class="anc-side-panel__body">
            <ng-content></ng-content>
        </div>
    </div>
</div>
